import type { ProjectsListTableRowActionsProps } from "./projects-list-table-row-actions.type";

import { useListTableRowActions } from "@/modules/list-table-row-actions";
import ModelDeleteButton from "@/modules/model-delete-button";
import ModelViewButton from "@/modules/model-view-button";
import { ProjectAssignButton } from "@/modules/project/project-assign";
import { ProjectEditButton } from "@/modules/project/project-edit-button";

export const ProjectsListTableRowActions = ({
  project,
}: ProjectsListTableRowActionsProps) => {
  const { closePopover } = useListTableRowActions();

  return (
    <>
      <ModelViewButton
        type="text"
        modelKey="project"
        item={project}
        onClick={closePopover}
      />
      <ProjectAssignButton
        type="text"
        project={project}
        onClick={closePopover}
        noIcon
      />
      <ProjectEditButton
        type="text"
        project={project}
        onClick={closePopover}
        noIcon
      />
      <ModelDeleteButton
        type="text"
        modelKey="project"
        item={project}
        onClick={closePopover}
        hideIcon
      />
    </>
  );
};
